import {ThemeType} from '@px/enum';
import {storageUtil} from '@px/helper/storage';

interface GlobalStorage extends StorageObject {
  themeType: ThemeType;
  visibility: 'hidden' | 'visible';
}

const STORAGE_KEY = 'global_storage';

export const globalStorage = {
  readGlobalStorage(): GlobalStorage {
    return storageUtil.readStorageObject(STORAGE_KEY, createInitGlobalStorage());
  },
  updateGlobalStorage(kv) {
    storageUtil.writeStorageObject(STORAGE_KEY, {...globalStorage.readGlobalStorage(), ...kv});
  },
};

function createInitGlobalStorage(): GlobalStorage {
  return {
    version: 1,
    themeType: ThemeType.Dark,
    visibility: 'visible',
  };
}
